var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10960_1287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10960_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10960_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.354 1.2168C9.98951 1.2168 6.42918 4.78932 6.42918 9.15374C6.42918 11.8225 7.7633 14.1857 9.79592 15.6234C5.05708 17.5222 1.69531 22.1556 1.69531 27.5619C1.70257 27.8886 1.83744 28.1995 2.07107 28.428C2.30471 28.6565 2.61852 28.7845 2.94531 28.7845C3.27211 28.7845 3.58592 28.6565 3.81955 28.428C4.05318 28.1995 4.18806 27.8886 4.19531 27.5619C4.19531 21.8243 8.81904 17.2006 14.5567 17.2006C16.5595 17.2006 18.4186 17.7716 20.001 18.7509C20.1411 18.8381 20.297 18.8968 20.4599 18.9237C20.6227 18.9505 20.7892 18.9449 20.9499 18.9073C21.1105 18.8696 21.2622 18.8007 21.3962 18.7044C21.5302 18.6081 21.6439 18.4863 21.7307 18.3459C21.8176 18.2057 21.8759 18.0496 21.9023 17.8867C21.9288 17.7238 21.9229 17.5573 21.8849 17.3967C21.8469 17.2361 21.7776 17.0846 21.681 16.9509C21.5843 16.8171 21.4623 16.7037 21.3218 16.6171C20.6087 16.1759 19.8347 15.8304 19.0366 15.5332C21.0027 14.0879 22.291 11.7685 22.291 9.15374C22.291 4.78932 18.7185 1.2168 14.354 1.2168ZM14.354 3.71914C17.3674 3.71914 19.7886 6.14038 19.7886 9.15374C19.7886 12.1672 17.3674 14.5786 14.354 14.5786C11.3406 14.5786 8.9292 12.1672 8.9292 9.15374C8.9292 6.14038 11.3406 3.71914 14.354 3.71914Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24.25C19.5 24.8081 19.6099 25.3608 19.8235 25.8764C20.0371 26.392 20.3501 26.8606 20.7448 27.2552C21.1394 27.6499 21.608 27.9629 22.1236 28.1765C22.6392 28.3901 23.1919 28.5 23.75 28.5C24.3081 28.5 24.8608 28.3901 25.3764 28.1765C25.892 27.9629 26.3606 27.6499 26.7552 27.2552C27.1499 26.8606 27.4629 26.392 27.6765 25.8764C27.8901 25.3608 28 24.8081 28 24.25C28 23.1228 27.5522 22.0418 26.7552 21.2448C25.9582 20.4478 24.8772 20 23.75 20C22.6228 20 21.5418 20.4478 20.7448 21.2448C19.9478 22.0418 19.5 23.1228 19.5 24.25Z",
    stroke: "#04385D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 21.8887V24.2498L25.1667 25.6664",
    stroke: "#04385D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10960_1287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReqIcon);
export default __webpack_public_path__ + "static/media/pendingReqIcon.b63054f35b2e36c4258bdd222d38b876.svg";
export { ForwardRef as ReactComponent };